import { Col, Row, Table, Typography } from "antd";
import moment from "moment";
import React from "react";
import lodash from "lodash";

const { Text } = Typography;
const IncomeStaffCompletedTable = (props) => {
  // -------------------------- VAR --------------------------
  const { jobList, userList } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      key: "date",
      title: "Job ID",
      align: "center",
      render: (_, record) => getDate(record),
      width: "20%",
    },
    {
      key: "services",
      title: "Services",
      align: "center",
      render: (_, record) => renderServices(record),
      width: "30%",
    },
    {
      title: "Total",
      dataIndex: "subtotal",
      key: "subtotal",
      align: "center",
      width: "20%",
      render: (value) => {
        return <Row justify="end">${value}</Row>;
      },
    },
    {
      title: "Staff",
      key: "mobile",
      align: "center",
      width: "30%",
      render: (_, record) => renderStaff(record),
    },
  ];

  const getDate = (record) => {
    const text = `${record?.name || "JobName"}`;
    return (
      <Row>
        <Text>{text}</Text>
      </Row>
    );
  };

  const renderServices = (record) => {
    const services = record?.services || [];
    const extraServices = record?.extraServices || [];
    const allServices = [...services, ...extraServices];
    return allServices?.map((service, index) => {
      const name =
        service.name.length > 20
          ? `${index + 1}. ${lodash.slice(service.name, 0, 20).join("")}...`
          : `${index + 1}. ${service.name}`;
      return (
        <Col span={24} key={index} align="left">
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>{name}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${service?.price}`}</Text>
              <Text code>x{service?.quantity}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };

  const renderStaff = (record) => {
    const staffs = record?.staffs || [];
    return staffs.map((staff, index) => {
      const [staffInfo] =
        userList?.filter((user) => user?.id === staff?.userId) || [];
      const staffName = staffInfo
        ? `${staffInfo?.firstName} ${staffInfo?.lastName}`
        : "No name";
      return (
        <Col span={24} key={index}>
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>{`${index + 1}. ${staffName}`}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${staff?.value}`}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };

  // -------------------------- MAIN --------------------------
  const sortedData = lodash.sortBy(jobList, ["bookingAt"]).reverse();
  return (
    <Table
      bordered
      columns={columns}
      dataSource={sortedData}
      pagination={false}
    />
  );
};
export default IncomeStaffCompletedTable;
